import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./user.module.css";
import { useNavigate } from "react-router-dom";
import { Grid, Pagination } from "@mui/material";
import { fetchAllUsers, user_delete_api, user_status_api } from "../api/user";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import { BiFilter, BiSearch } from "react-icons/bi";
import DataNotFound from "../ErrorPage/DataNotFound";
import DeletePopup from "../Dialogbox/DeletePopup";
import FilterPopup from "../Dialogbox/FilterPopup";
import { getBaseUrl, getBaseUrl2 } from "../../utils";
import TablePaginationDemo from "../../Common/CustomPageData";
import xlsx from "json-as-xlsx";
import { toast } from "react-toastify";

const MainPage = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [allUsers, setallUsers] = useState([]);
  const [pageCount, setpageCount] = useState(1);
  const [deleteId, setdeleteId] = useState("");
  const [deletedialobbox, setdeletedialobbox] = useState(false);
  const [deletename, setdeletename] = useState();
  const [pageLength, setpageLength] = useState();
  const [search, setsearch] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [totalData, setTotalData] = useState("");
  const [limit, setLimit] = useState(10);
  const [statusFilter, setstatusFilter] = useState();
  useEffect(() => {
    fetchAllUsersFunc();
  }, [pageCount, search, startDate, endDate, limit, statusFilter]);

  async function fetchAllUsersFunc(data) {
    setisLoading(true);
    try {
      const temp = {
        page: pageCount,
        limit: limit,
        search: search.trim(),
        startDate: startDate,
        endDate: endDate,
        status: statusFilter,
      };
      let res = await fetchAllUsers(temp);
      if (res.data.status) {
        setallUsers(res.data.users);
        setpageLength(res?.data?.totalPages);
        setTotalData(res?.data?.total_data);
        setisLoading(false);
      } else {
        setisLoading(false);
        console.log("status false!");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--clr-theme)",
      color: theme.palette.common.white,
      fontWeight: "bold",
      borderRight: "1px solid #fff",
      overflow: "hidden",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "none",
      borderLeft: "2px solid #00000011",
      "&:last-child": {
        borderRight: "2px solid #00000011",
      },
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "2px solid #00000011",
  }));

  async function deleteuserFunc() {
    setisLoading(true);
    let temp = {
      id: deleteId,
    };
    try {
      let res = await user_delete_api(temp);
      console.log(res);
      if (res.data.status) {
        setisLoading(false);
        setdeletedialobbox(false);
        // fetchAllUsersFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  }

  const user_status = async (data) => {
    setisLoading(true);
    let temp = {
      id: data._id,
      status: data.status === true ? false : true,
    };
    try {
      let res = await user_status_api(temp);
      console.log(res);
      if (res.data.status) {
        setisLoading(false);
        fetchAllUsersFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  };

  let settings = {
    fileName: "User List", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    // RTL: true, // Display the columns from right-to-left (the default value is false)
  };

  const exportTransactionFunc = (adiminTransaction) => {
    if (adiminTransaction.length < 1) {
      return toast.alert("No Data available foe export");
    }
    let data = [
      {
        sheet: "Users Data",
        columns: [
          {
            label: "Created Date",
            value: (row) =>
              row?.created_at ? row?.created_at?.slice(0, 10) : "",
          },
          {
            label: "Status",
            value: (row) => (row?.status ? row?.status : ""),
          },

          {
            label: "Event Name",
            value: (row) => (row?.eventId ? row?.eventId?.name : ""),
          },
          {
            label: "User Phone No.",
            value: (row) => (row?.phone ? row?.phone : ""),
          },
          {
            label: "User Name",
            value: (row) => (row?.name ? row?.name : ""),
          },
          {
            label: "Date of Birth",
            value: (row) => (row?.dob ? row?.dob : ""),
          },
          {
            label: "E-mail",
            value: (row) => (row?.email ? row?.email : ""),
          },
          {
            label: "Gotra",
            value: (row) => (row?.gotra ? row?.gotra : ""),
          },
          {
            label: "Login Type",
            value: (row) => (row?.loginType ? row?.loginType : ""),
          },
          {
            label: "Gotra",
            value: (row) => (row?.gotra ? row?.gotra : ""),
          },
          // {
          //   label: "Transaction ID",
          //   value: (row) => (row?.transactionId ? row?.transactionId : ""),
          // },
          // {
          //   label: "Order ID",
          //   value: (row) => (row?.orderId ? row?.orderId : ""),
          // },
          // {
          //   label: "Payment ID",
          //   value: (row) => (row?.paymentId ? row?.paymentId : ""),
          // },
        ],
        content: adiminTransaction,
      },
    ];
    let callback = function (sheet) {
      console.log("Download complete:", sheet);
    };
    try {
      xlsx(data, settings, callback);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="">
      <div className="beat_heading">
        <div className={s["user-list-heading"]}>
          <div className="user-list-title">
            <h3>Users List</h3>
          </div>
          <div className={s["user-list-search"]}>
            <div className={s["search-box"]}>
              <span style={{ paddingRight: "0.5rem" }}>
                <BiSearch size={23} />
              </span>
              <input
                type="text"
                spellCheck="false"
                onChange={(e) => {
                  setpageCount(1);
                  setsearch(e.target.value);
                }}
                placeholder="Search users by name.."
              />
            </div>
            <div className={s["title"]}>
              <span
                onClick={() => exportTransactionFunc(allUsers)}
                style={{ paddingRight: "2px" }}
              >
                Export to Excel
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className={s["date_input_box"]}>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setstartDate(e.target.value)}
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setendDate(e.target.value)}
          />
          <select onChange={(e) => setstatusFilter(e.target.value)}>
            <option value="">Select Status filter</option>
            <option value="pending">pending</option>
            <option value="success">success</option>
            <option value="failed">failed</option>
          </select>
        </div>
        {/* <div className={s["mock_test_dropdown"]}></div>
                <div className={s["mock_test_dropdown"]}></div> */}
      </div>
      <div className="beat_table" style={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Image</StyledTableCell>
              <StyledTableCell align="center">User</StyledTableCell>
              <StyledTableCell align="center">Status</StyledTableCell>
              <StyledTableCell align="center">Transaction</StyledTableCell>
              <StyledTableCell align="center">User Details</StyledTableCell>
              <StyledTableCell align="center">
                Subscription Transaction
              </StyledTableCell>
              {/* <StyledTableCell align="center">Action</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {allUsers.map((row) => (
              <StyledTableRow key={row.id}>
                <StyledTableCell>
                  {row.profile_image ? (
                    <img
                      style={{ height: "2rem", width: "3rem" }}
                      src={getBaseUrl2() + row?.profile_image?.url}
                      alt=""
                    />
                  ) : null}
                </StyledTableCell>
                <StyledTableCell>
                  <div>
                    <p>
                      <b>Name:</b>
                      {row?.name}
                    </p>
                    <p>
                      <b>Mobile No.:</b>
                      {row?.phone}
                    </p>
                    <p>
                      <b>Email:</b>
                      {row?.email}
                    </p>
                    <p>
                      <b>Sign Up:</b>
                      {row?.created_at?.slice(0, 10)}
                    </p>
                    {/* <p>
                      <b>College Name:</b>
                      {row?.user?.collegeName}
                    </p> */}
                  </div>
                </StyledTableCell>

                <StyledTableCell align="center">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => user_status(row)}
                    className={`${
                      row.status === true ? s.active_admin : s.inactive_admin
                    }`}
                  >
                    {`${row.status === true ? "Active" : "InActive"}`}
                  </div>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <div
                    className={s["title"]}
                    onClick={() =>
                      navigate("/transaction-list", {
                        state: {
                          pagetype: "Add",
                          data: row,
                        },
                      })
                    }
                  >
                    Transactions
                  </div>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <div
                    className={s["title"]}
                    onClick={() =>
                      navigate("/user-details", {
                        state: {
                          pagetype: "Add",
                          data: row,
                        },
                      })
                    }
                  >
                    User Detail
                  </div>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <div
                    className={s["title"]}
                    onClick={() =>
                      navigate("/Subscription-transaction-list", {
                        state: {
                          pagetype: "Add",
                          data: row,
                        },
                      })
                    }
                  >
                    Subscription Transaction
                  </div>
                </StyledTableCell>
                {/* <StyledTableCell align="center">
                  <CiEdit
                    onClick={() =>
                      navigate("/useradd", {
                        state: {
                          pagetype: "Edit",
                          data: row,
                        },
                      })
                    }
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      marginRight: "0.5rem",
                      cursor: "pointer",
                    }}
                  />
                  <MdDelete
                    onClick={() => {
                      setdeletedialobbox(true);
                      setdeletename(row.user_name);
                      setdeleteId(row.id);
                    }}
                    style={{ fontSize: "1rem", color: "var(--clr-primary)", cursor: "pointer" }}
                  />
                </StyledTableCell> */}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {allUsers.length <= 0 && <DataNotFound />}
        {allUsers?.length > 0 && (
          <TablePaginationDemo
            totalData={totalData}
            rowOnAPage={limit}
            setLimit={setLimit}
            pageNo={pageCount}
            setpageCount={setpageCount}
          />
        )}
        {allUsers?.length > 0 && (
          <div className={s["pagination"]}>
            <Pagination
              count={pageLength}
              size="large"
              style={{ color: "#D21903" }}
              onChange={(e, value) => setpageCount(value)}
              page={pageCount}
            />
          </div>
        )}
      </div>
      <DeletePopup
        open={deletedialobbox}
        name={deletename}
        close={() => setdeletedialobbox(!deletedialobbox)}
        onsubmit={() => {
          deleteuserFunc();
        }}
      />
      <Loder loading={isLoading} />
    </div>
  );
};

export default MainPage;
